module.exports = __webpack_public_path__ + "static/img/get-to-the-management-team_6.f98d686.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-us/get-to-the-management-team_6.png
// module id = dc3t
// module chunks = 0